export default __webpack_public_path__ + "media/src/assets/images/MapPinInBound-e601a025da4008db5043f8c2b23fb356.svg";